import script from "./OperatorApplicationSuggestedTemplate.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationSuggestedTemplate.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationSuggestedTemplate.vue?vue&type=style&index=0&id=20e220d4&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20e220d4"]])

export default __exports__